const IMAGES = {
  logo: "/images/logo.png",
  bgS1: "/images/bgS1.jpg",
  textX: "/images/textX.png",
  bttDown: "/images/bttDown.png",
  btnOpen: "/images/btnOpen.png",
  arrowL: "/images/arrowL.png",
  arrowR: "/images/arrowR.png",
  bgQr: "/images/bgQr.png",
  mockup: "/images/mockup.png",
  borderQr: "/images/borderQr.png",
  blur: "/images/blur.png",
  thumb: "/images/thumbnail.jpg",
  bttQr: "/images/qrBtt.png",
  bgCalendar: "/images/bgCalendar.png",
  bgCalendarMb: "/images/bgCalendarMb.png",
  logoCalendar: "/images/logoCalendar.png",
  z1: "/images/z1.png",
  z2: "/images/z2.png",
  z3: "/images/z3.png",
  z4: "/images/z4.png",
  z5: "/images/z5.png",
  z6: "/images/z6.png",
  z7: "/images/z7.png",
  z8: "/images/z8.png",
  z9: "/images/z9.png",
  z10: "/images/z10.png",
  z11: "/images/z11.png",
  z12: "/images/z12.png",
  phone: "/images/phone.svg",
  qr: "/images/qr.png",
  bgBig: "/images/bgBig.jpg",
  sanh: "/images/sanh.webp",
  textC: "/images/textC.png",
  ptLogo: "/images/ptLogo.png",
  xheroLogo: "/images/xheroLogo.png",
  bgZodiac: "/images/bgZodiac.png",
  bttDowF: "/images/bttDowF.png",
  loadingLogo: "/images/loadingLogo.svg",
  download: "/images/download.png",
  features: "/images/feature.png",
  calendar: "/images/calendar.png",
  access: "/images/access.png",
  cucVang: "/images/cucVang.svg",
  overlay: "/images/overlay.png",
  line: "/images/line.png",
  minusIcon: "/images/minusIcon.png",
  plusIcon: "/images/plusIcon.png",
  phoneImage: "/images/phone.png",
  underPhone: "/images/underPhone.png",
  logoNgang: "/images/logoNgang.png",
  qrApp: "/images/ScanQR1.png",
  buttonSlide: "/images/buttonSlide.png",
  buttonSlideDeactive: "/images/buttonSlideDeactive.png",
  laKinhImg: "/images/laKinhImg.png",
  xemPhongThuy: "/images/xemPhongThuy.png",
  xemNgay: "/images/xemNgay.png",
  giaPha: "/images/giaPha.png",
  ketNoiChuyenGia: "/images/ketNoiChuyenGia.png",
  ketNoiCG: "/images/ketNoiCG.png",
  chuyenGia: "/images/chuyenGia.png",
  xCheck: "/images/x-check.png",
  Xcheck: "/images/xCheck.png",
  suKienCaNhan: "/images/suKienCaNhan.png",
  daoDuc: "/images/daoDuc1.png",
  ketNoi: "/images/ketNoi1.png",
  nhanVan: "/images/nhanVan1.png",
  tamLinh: "/images/tamLinh1.png",
  truyenThong: "/images/truyenThong1.png",
  vanHoa: "/images/vanHoa1.png",
  orbitBg: "/images/orbitBG3.png",
  orbitBgMB: "/images/orbitBgMB1.png",
  ttndLogo: "/images/ttndLogo.png",
  dot: "/images/dot.svg",
  iconArrowNo: "/images/iconArrowNo.png",
  iconArrow: "/images/iconArrow.png",
  FAQBg: "/images/FAQBg.png",
  tenLua: "/images/tenlua.png",
  icon: "../images/icon.png",
  icon1: "../images/icon1.png",
  icon2: "../images/icon2.png",
  icon3: "../images/icon3.png",
  icon4: "../images/icon4.png",
  icon5: "../images/icon5.png",
  fb: "../images/fb.png",
  zalo: "../images/zalo.png",
  tiktok: "../images/tiktok.png",
  ytb: "../images/ytb.png",
  menu: "../images/menu.png",
  icon_1: "../images/icon_1.png",
  icon_2: "../images/icon_2.png",
  icon_3: "../images/icon_3.png",
  icon_4: "../images/icon_4.png",
  icon_bds: "../images/icon_bds.png",
  icon_daotao: "../images/icon_daotao.png",
  icon_giapha: "../images/icon_giapha.png",
  icon_lakinh: "../images/icon_lakinh.png",
  icon_nhangden: "../images/icon_nhangden.png",
  icon_phongthuy: "../images/icon_phongthuy.png",
  icon_quantri: "../images/icon_quantri.png",
  icon_vatpham: "../images/icon_vatpham.png",
  bongbong1: "../images/bongbong1.png",
  logodoc: "../images/logodoc.png",
  bongvang: "../images/bongvang.png",
  menubg: "../images/menubg1.png",
  iconClose: "../images/iconClose.png",
  iconSuss: "../images/iconSuss.png",
  iconErr: "../images/iconErr.png",
  wave: "../images/wave.png",
  waveAbout: "../images/waveAbout.png",
  bgNum: "../images/bgNum.png",
  bgNum2: "../images/bgNum2.png",
  close: "../images/iconClose.svg",
  loadingOutside: "../images/loadingOutside.png",
  loadingInside: "../images/loadingInside.png",
  phone1: "../images/phone1.svg",
  phone2: "../images/phone2.png",
  line1: "../images/line1.svg",
  vongCau: "../images/vongCau.png",
  logoPT: "/images/logoPT.png",
  bgCalendarP: "/images/bgCalendarP.png",
  headerLogo: "/images/headerLogo.svg",
  sunrise: "/images/sunrise.svg",
  sunlunch: "/images/sunlunch.svg",
  sunset: "/images/sunset.svg",
  ti: "/images/ti.svg",
  suu: "/images/suu.svg",
  dan: "/images/dan.svg",
  mao: "/images/mao.svg",
  thin: "/images/thin.svg",
  ty: "/images/ty.svg",
  ngo: "/images/ngo.svg",
  mui: "/images/mui.svg",
  than: "/images/than.svg",
  dau: "/images/dau.svg",
  tuat: "/images/tuat.svg",
  hoi: "/images/hoi.svg",
  shouddo: "/images/shouddo.svg",
  limit: "/images/limit.svg",
  sunrisered: "/images/sunrisered.svg",
  sunlunchred: "/images/sunlunchred.svg",
  sunsetred: "/images/sunsetred.svg",
  shoulddored: "/images/shoulddored.svg",
  tired: "/images/tired.svg",
  suured: "/images/suured.svg",
  danred: "/images/danred.svg",
  maored: "/images/maored.svg",
  thinred: "/images/thinred.svg",
  tyred: "/images/tyred.svg",
  ngored: "/images/ngored.svg",
  muired: "/images/muired.svg",
  thanred: "/images/thanred.svg",
  daured: "/images/daured.svg",
  tuatred: "/images/tuatred.svg",
  hoired: "/images/hoired.svg",
  tiblue: "/images/tiblue.svg",
  suublue: "/images/suublue.svg",
  danblue: "/images/danblue.svg",
  maoblue: "/images/maoblue.svg",
  thinblue: "/images/thinblue.svg",
  tyblue: "/images/tyblue.svg",
  ngoblue: "/images/ngoblue.svg",
  muiblue: "/images/muiblue.svg",
  thanblue: "/images/thanblue.svg",
  daublue: "/images/daublue.svg",
  tuatblue: "/images/tuatblue.svg",
  hoiblue: "/images/hoiblue.svg",
  shoulddoblue: "/images/shoulddoblue.svg",
};

export default IMAGES;
